import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import { Template } from 'devextreme-react/core/template';
import Imag from '../../../images/logo.png';
import { UserPanel } from '../user-panel/UserPanel';
import { Popover } from 'devextreme-react/popover';
import List from 'devextreme-react/list';
import type { AppHeaderProps } from '../../../types';
//import { Notification } from '../../../types/types.notifications';
import './Header.scss';
import { formatMessage } from 'devextreme/localization';
//import { newToast } from '../..';
import { useNavigate } from 'react-router-dom';
//import { setCurrentPath, deleteNotification, deleteNotificated } from '../../../contexts/slices/notifications';
//import { getConnectionById } from '../../../contexts/slices/signalr';
import { useApiOrders } from '../../../api/api.orders';
import { LoadIndicator, Popup, Switch, Tooltip, DropDownButton } from 'devextreme-react';
//import { useSignalROrders } from '../../../signalR';
import { setEditingMode } from '../../../contexts/slices/config';
//import ChatBot from '../../utils/chatbot-popup/ChatbotPopUp';
//import { useApiDashBoard } from '../../../api/api.dashboards';
//import { setLoadingPpal } from '../../../contexts/slices/dashboards';
import useSessionManager from '../session-manager/useSessionManager';
import { useScreenSize } from '../../../utils/media-query';
import ModalBarcodesPrinters from '../../utils/modal-barcodes-printers/ModalBarcodesPrinters';
import { setFilteresToOrders } from '../../../contexts/slices/orders';
import { FilteredOrders } from '../../../types/types.orders';
import { ConvertLocalDate } from '../../../utils/functions';
import { useFilterAutoExecution } from '../../../hooks/useFilterAutoExecution';
import { useControlBoards } from '../../../hooks/useControlBoards';
import { BoardPopup } from '../../utils/board-popup/BoardPopup';
import { board, microscopieBlue } from '../../../images/icons';

// const notificationRender = (item) => {
//   let Head = item.Type;
//   let color = '#000';
//   let icon = 'home';
//   switch (item.Type) {
//     case 'order':
//       Head = formatMessage('OrdNotificationType');
//       color = '#03A9F4';
//       icon = 'info';
//       break;
//     default:
//       break;
//   }

//   return (
//     <div className='notification-item'>
//       <b className='notification-type' style={{ color: color }}>
//         <i className={`dx-icon-${icon}`} style={{ marginRight: 5, fontSize: 15, color: '#FB983B' }}></i>
//         {Head}
//       </b>
//       <div className='notification-message'>{item.Message}</div>
//     </div>
//   );
// };

const getReportIcon = (name?: string) => {
  const n = (name || '').toLowerCase();
  if (n.includes('factura')) return 'money';
  if (n.includes('venta')) return 'cart';
  if (n.includes('estadist') || n.includes('total') || n.includes('estad')) return 'chart';
  if (n.includes('examen') || n.includes('exámenes') || n.includes('examenes')) return 'microscopie';
  if (n.includes('informe') || n.includes('remit')) return 'doc';
  if (n.includes('vendedor') || n.includes('vended')) return 'group';
  if (n.includes('médico') || n.includes('medico') || n.includes('doctor')) return 'user';
  return 'doc';
};

const boardItemRender = (item: any) => {
  const name = item?.Rp_Nombre || '';
  const icon = getReportIcon(name);
  const itemId = `board-item-${item?.Rp_Id || Math.random()}`;

  return (
    <div className='board-dropdown-item-content' id={itemId} title={name}>
      <div className='board-item-icon'>{icon === 'microscopie' ? <img src={microscopieBlue} alt='microscopio' className='board-svg-icon' /> : <i className={`dx-icon dx-icon-${icon}`}></i>}</div>
      <div className='board-item-name'>{name}</div>
    </div>
  );
};

export const AppHeader = ({ menuToggleEnabled, toggleMenu, className }: AppHeaderProps) => {
  const authenticated = useAppSelector((x) => x.configuration.IsAuthenticated);
  const modeEdition = useAppSelector((x) => x.configuration.IsEditing);
  const userInfo = useAppSelector((x) => x.userInfo);
  const userName = userInfo?.User?.Us_Nombre || userInfo?.Profile?.Pe_Nombre || userInfo?.User?.Us_Usuario || 'Usuario';

  //const Prm_Conf_Campos_Diseno = useAppSelector((x) => x.userInfo.Permissions?.Prm_Conf_Campos_Diseno) ?? false;
  const [modalEditingVisible, setModalEditingVisible] = useState<boolean>(false);
  const currentFilters = useAppSelector((x) => x.globalOrders.FiltersToOrders);
  const Prm_Ord = useAppSelector((x) => x.userInfo.Permissions?.Prm_Ord) ?? false;
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  //const { dashboards, loading: LoadingDashBoard } = useAppSelector((x) => x.dashboards);
  const { isMedium, isLarge } = useScreenSize();

  //const useApiDb = useApiDashBoard();
  //const { getData, getConfigDb } = useApiDb;
  //const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  //const location = useAppSelector((x) => x.userInfo.Location);
  //const SignalRDataChangeByLocations = useAppSelector((x) => x.configuration.Data?.Config_General.find((x) => x.Cgn_Nombre === 'SignalRDataChangeByLocations')?.Cgn_Resultado);
  //const notifications = useAppSelector((x) => x.notifications);
  //const [showNotifications, setShowNotifications] = useState(false);
  const { findOrder } = useApiOrders();
  //const { DataChangeIsconnected, DataChangeId } = useAppSelector((x) => x.signalR);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Hook para manejar la ejecución automática de filtros
  useFilterAutoExecution();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingPatient, setLoadingPatient] = useState<boolean>(false);
  const [loadingIdSearch, setLoadingIdSearch] = useState<boolean>(false);
  const refSearchById = useRef<TextBox>(null);
  //const { putData, putNotas } = useSignalROrders();
  const refSearch = useRef<TextBox>(null);
  const refSearchPatient = useRef<TextBox>(null);

  // Hook para tableros de control
  const { boards, loading: boardsLoading, selectedBoard, selectBoard } = useControlBoards();
  const [boardPopupVisible, setBoardPopupVisible] = useState<boolean>(false);
  const [boardMinimized, setBoardMinimized] = useState<boolean>(false);
  const [boardSearchText, setBoardSearchText] = useState<string>('');
  const [showBoardsPopover, setShowBoardsPopover] = useState<boolean>(false);

  // Filtrar tableros por texto de búsqueda
  const filteredBoards = useMemo(() => {
    if (!boardSearchText || boardSearchText.trim() === '') {
      return boards;
    }
    const searchLower = boardSearchText.toLowerCase().trim();
    return boards.filter((b: any) => (b.Rp_Nombre || '').toLowerCase().includes(searchLower));
  }, [boards, boardSearchText]);

  //UseEffect que controla las teclas.
  useEffect(() => {
    document.addEventListener('keydown', handleKeys);
    return () => {
      document.removeEventListener('keydown', handleKeys);
    };
  }, []);

  // //Useeffect que controla las notificaciones del sistema.
  // useEffect(() => {
  //   notifications.Notification.filter((x) => x.State === 'pending').forEach((element) => {
  //     newToast('INFO', element.Message, 5);
  //     dispatch(deleteNotificated(element.Id));
  //   });
  // }, [notifications.Notification]);

  // useEffect(() => {
  //   if (dashboards.length === 0) {
  //     getConfigDb();
  //   } else {
  //     if (LoadingDashBoard) {
  //       const fetchAllData = async () => {
  //         // Ejecutar todas las llamadas a `getData` y esperar a que terminen
  //         await Promise.all(dashboards.map((dashboard) => getData(dashboard.Db_Id)));
  //         // Cambiar el estado de LoadingDashBoard solo cuando todas las tareas terminen
  //         dispatch(setLoadingPpal(false));
  //       };

  //       fetchAllData();
  //     }
  //   }
  // }, [dashboards.length, LoadingDashBoard]);

  // useEffect(() => {
  //   if (DataChangeIsconnected && DataChangeId) {
  //     const conex = getConnectionById(DataChangeId);
  //     //Verificamos si nos matriculamos a un notificador por sede o general
  //     if (SignalRDataChangeByLocations && Boolean(SignalRDataChangeByLocations)) {
  //       conex?.on(`Orden_${location}`, (data) => {
  //         putData(data);
  //       });
  //       return () => {
  //         conex?.off(`Orden_${location}`);
  //       };
  //     } else {
  //       conex?.on(`Orden`, (data) => {
  //         putData(data);
  //       });
  //       return () => {
  //         conex?.off(`Orden`);
  //       };
  //     }
  //   }
  // }, [DataChangeIsconnected, idOrd]);

  // const handleClickNotifications = (e) => {
  //   const item: Notification = { ...e.addedItems[0] };
  //   if (item && item.Url) {
  //     // Verificar que item y item.Url estén definidos
  //     navigate(item.Url);
  //     dispatch(setCurrentPath(item.Url));
  //   }
  //   toggleNotifications();
  //   dispatch(deleteNotification(item.Id));
  // };

  const handleKeys = (event) => {
    if (authenticated) {
      if (event.ctrlKey && event.key.toUpperCase() === 'F') {
        event.preventDefault();
      }
      if (event.ctrlKey && event.altKey && event.key.toUpperCase() === 'O') {
        setModalEditingVisible(true);
        event.preventDefault();
      }
    }
  };

  const handleVisibleModalEditing = useCallback(() => {
    setModalEditingVisible(false);
  }, []);

  // function toggleNotifications() {
  //   setShowNotifications(!showNotifications);
  // }

  const handleChangeOrder = (e) => {
    if (!e.value) {
      return;
    }
    setLoading(true);
    findOrder(e.value, undefined, setLoading, true).finally(() => {
      refSearch.current?.instance.reset();
    });
  };

  const handleSearchById = (e) => {
    const id = Number(e.value);
    if (!id || isNaN(id)) return;
    setLoadingIdSearch(true);
    findOrder(undefined, id, setLoadingIdSearch, true).finally(() => {
      refSearchById.current?.instance.reset();
      setModalEditingVisible(false);
    });
  };

  const handleSearchPatient = (e) => {
    const document = e.value;
    if (!document || document.trim() === '') {
      return;
    }
    setLoadingPatient(true);
    //const today = ConvertLocalDate(new Date());
    const filters: FilteredOrders = {
      Servicios: [],
      Fechas: [null, null],
      Areas: [],
      Estudios: [],
      Estados: [],
      Redirect: true,
      Paciente: document.trim(),
    };
    dispatch(setFilteresToOrders(filters));
    navigate('/admin-orders', { state: { selectedTabId: 1 } });
    setLoadingPatient(false);
    refSearchPatient.current?.instance.reset();
  };

  useEffect(() => {
    //currentFilters
    if (currentFilters == null || !currentFilters || (currentFilters.Fechas.length === 0 && Prm_Ord)) {
      // Obtener la fecha en hora local
      const today = ConvertLocalDate(new Date());
      const filters: FilteredOrders = {
        Fechas: [today, today],
      };
      dispatch(setFilteresToOrders(filters));
    }
  }, []);

  const handleStateChange = useCallback((value) => {
    dispatch(setEditingMode(value));
    handleVisibleModalEditing();
  }, []);

  // Handlers para tableros de control
  const handleBoardSelect = useCallback(
    (e: any) => {
      const board = e.itemData;
      if (board) {
        selectBoard(board);
        setBoardPopupVisible(true);
        setBoardMinimized(false);
        setShowBoardsPopover(false);
        setBoardSearchText('');
      }
    },
    [selectBoard]
  );

  const toggleBoardsPopover = useCallback(() => {
    setShowBoardsPopover((prev) => !prev);
    if (!showBoardsPopover) {
      setBoardSearchText('');
    }
  }, [showBoardsPopover]);

  const handleCloseBoardPopup = useCallback(() => {
    setBoardPopupVisible(false);
    setBoardMinimized(false);
  }, []);

  const handleMinimizeBoardPopup = useCallback(() => {
    setBoardMinimized(true);
  }, []);

  const handleMaximizeBoardPopup = useCallback(() => {
    setBoardMinimized(false);
  }, []);

  //Control de sesión robusto
  useSessionManager();

  return (
    <header className={`header-component ${className}`}>
      <Toolbar className='header-toolbar'>
        <Item visible={menuToggleEnabled} location='before' widget='dxButton' cssClass='menu-button'>
          <Button icon='menu' stylingMode='text' onClick={toggleMenu} />
        </Item>
        {(isLarge || isMedium) && (
          <Item location='before' cssClass='header-title'>
            <img src={Imag} alt='Logo' style={{ maxWidth: '130px' }} />
          </Item>
        )}
        <Item location='after' visible={Prm_Ord} locateInMenu='auto' cssClass='global-search-box'>
          <div className='search-container'>
            <TextBox placeholder='Buscar documento' ref={refSearchPatient} disabled={loadingPatient} onValueChanged={handleSearchPatient} width={180} mode='search' stylingMode='outlined' labelMode='static' />
            <LoadIndicator visible={loadingPatient} width={20} height={20} />
          </div>
        </Item>
        <Item location='after' visible={Prm_Ord} locateInMenu='auto' cssClass='global-search-box'>
          <div className='search-container'>
            <TextBox placeholder={formatMessage('search')} ref={refSearch} disabled={loading} onValueChanged={handleChangeOrder} width={180} mode='search' stylingMode='outlined' labelMode='static' />
            <LoadIndicator visible={loading} width={20} height={20} />
          </div>
        </Item>

        <Item location='after' visible={authenticated} locateInMenu='auto' cssClass='boards-dropdown-item'>
          <div id='TabControlBoards' className='boards-dropdown-button' onClick={toggleBoardsPopover}>
            <Button
              icon={board}
              stylingMode='text'
              disabled={boardsLoading || boards.length === 0}
            />
            <i className='dx-icon dx-icon-spindown boards-dropdown-arrow'></i>
          </div>
          <Popover
            visible={showBoardsPopover}
            target='#TabControlBoards'
            position='bottom'
            width={400}
            hideOnOutsideClick={true}
            onHiding={() => setShowBoardsPopover(false)}
            showCloseButton={false}
          >
            <div className='boards-dropdown-content'>
              <div className='boards-dropdown-search'>
                <TextBox
                  placeholder='Buscar tablero...'
                  value={boardSearchText}
                  onValueChanged={(e) => setBoardSearchText(e.value || '')}
                  mode='search'
                  stylingMode='outlined'
                  width='100%'
                />
              </div>
              <div className='boards-dropdown-list'>
                <List
                  dataSource={filteredBoards}
                  keyExpr='Rp_Id'
                  height={300}
                  itemRender={boardItemRender}
                  selectionMode='single'
                  selectByClick={true}
                  onItemClick={handleBoardSelect}
                  noDataText='No se encontraron tableros'
                />
              </div>
            </div>
          </Popover>
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#TabControlBoards'}>
            Tableros
          </Tooltip>
        </Item>

        {/* <Item location='after'>
          <div className='messages' id='menuNotify'>
            <Button icon='belloutline' onClick={toggleNotifications} />
            {notifications.Notification.length > 0 && <div className='dx-badge'>{notifications.Notification.length}</div>}
            <Popover visible={showNotifications} target='#menuNotify' width={300} height={300} showCloseButton={true}>
              <div className='list-container'>
                <List dataSource={notifications.Notification} itemRender={notificationRender} selectionMode='single' selectByClick={true} onSelectionChanged={handleClickNotifications} />
              </div>
            </Popover>
          </div>
        </Item> */}
        <Item location='after' locateInMenu='auto' menuItemTemplate='userPanelTemplate'>
          <div className='user-panel-container'>
            {isLarge && (
              <span className='user-name-display' style={{ marginTop: -5 }}>
                {userName}
              </span>
            )}
            <UserPanel menuMode='context' />
          </div>
        </Item>
        <Template name='userPanelTemplate'>
          <UserPanel menuMode='list' />
        </Template>
      </Toolbar>
      <Popup title='Panel administrativo' visible={modalEditingVisible} hideOnParentScroll={true} width={400} height={380} showCloseButton={true} onHidden={handleVisibleModalEditing}>
        {idOrd && idOrd !== -1 && <p>Id Orden: {idOrd}</p>}
        <div className='dx-fieldset'>
          <div className='dx-field'>
            <div className='dx-field-label'>Buscar por ID de orden</div>
            <div className='dx-field-value' style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <TextBox ref={refSearchById} placeholder='ID de orden' disabled={loadingIdSearch} onValueChanged={handleSearchById} width={180} mode='search' stylingMode='outlined' labelMode='static' />
              <LoadIndicator visible={loadingIdSearch} width={20} height={20} />
            </div>
          </div>
        </div>
        <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '10px 0' }} />
        <p>Activar o desactivar modo de edición y personalización de fomularios</p>
        <div>
          <div className='dx-fieldset'>
            <div className='dx-field'>
              <div className='dx-field-label'>{modeEdition ? 'DESACTIVAR' : 'ACTIVAR'}</div>
              <div className='dx-field-value'>
                <Switch defaultValue={modeEdition} onValueChange={handleStateChange} />
              </div>
            </div>
          </div>
        </div>
      </Popup>

      {Prm_Ord && <ModalBarcodesPrinters />}
      {/* <ChatBot /> */}
      <BoardPopup
        visible={boardPopupVisible}
        board={selectedBoard}
        onHide={handleCloseBoardPopup}
        isMinimized={boardMinimized}
        onMinimize={handleMinimizeBoardPopup}
        onMaximize={handleMaximizeBoardPopup}
      />
    </header>
  );
};
